import { action, makeObservable, observable } from "mobx";

export class FilterStore {
	@observable filters: Record<string, any> = {};

	constructor() {
		makeObservable(this);
	}

	@action.bound
	set(key: string, value: any) {
		this.filters[key] = value;
	}

	@action.bound
	remove(key: string) {
		delete this.filters[key];
	}

	@action.bound
	clear() {
		this.filters = {};
	}

	getQueryParams(): URLSearchParams {
		return Object.entries(this.filters).reduce((params, [key, value]) => {
			if (value != null && value !== "") {
				params.append(key, String(value));
			}
			return params;
		}, new URLSearchParams());
	}
}
